import { isDevEnv } from 'utils/isDevEnv';
import { EventCollectorPayload } from './payloads';

async function fetchEventCollector(event: EventCollectorPayload) {
  // TODO: Don't test on Cypress

  if (window && (window as any).Cypress) {
    return;
  }

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(event),
  };

  try {
    await fetch(import.meta.env.VITE_EVENT_COLLECTOR_URL, options);
  } catch (e) {
    if (isDevEnv()) {
      console.error('Event collector request failed');
      console.error(e);
    }
  }
}

export default fetchEventCollector;
